import { createSelector } from 'reselect';

const getUser = (state) => state.user;

export const userSignedIn = createSelector([getUser], (user) => !!user);
export const isAnonymous = createSelector(
    [getUser],
    (user) => user && user.isAnonymous
);
